const config = {
    apiDomain: 'https://dl.pixotope.cloud/papi',
    // apiDomain: 'http://127.0.0.1:8080',
  };
  
  export default config;